import { TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';
import { StringService } from '../../services/string';
import { AdobeTracking } from '../../tracking-services';
import { DefaultLinkClickData } from '../../tracking-services/types';
import { RocheTextLink as RocheTextLinkType } from '../../types/global';

export const trackTextLink = (blok: RocheTextLinkType): void => {
  const adobeTracking: DefaultLinkClickData = {
    innerText: blok.text,
    url: StringService.sanitizeUrl(blok.href ?? ''),
    type: 'Button',
    position: 'TextLink',
    socialMedia: blok.type === 'footer-social' ? blok.text : '',
    socialInteraction: blok.type === 'footer-social' ? 'Link' : '',
  };
  const defaultTracking = {
    event: 'link_click',
    component_name: 'text-link',
    additionalParameters: {
      click_url: blok.href ?? '',
      click_text: blok.text ?? '',
    },
  };

  TrackingService.push(defaultTracking);
  AdobeTracking(adobeTracking, 'defaultLinkClick');
};
